import Vue from 'vue'
import Router from 'vue-router'
import { ABOUT_NAV, SERVICE_NAV } from '@/constants/hiraysData'
import { ABOUT_NAV_LINKS } from '@/constants/hiraysHomeStatic'

Vue.use(Router)

const aboutRedirects = ABOUT_NAV.map(a => {
  const link = ABOUT_NAV_LINKS.find(l => l.slug === a.slug)
  const hash = link && link.hash ? link.hash : 'page11'
  return {
    path: '/about/' + a.slug + '/',
    redirect: () => '/about/#' + hash
  }
})

const serviceRoutes = SERVICE_NAV.map(s => ({
  path: '/service/' + s.slug + '/',
  name: 'Service_' + s.slug,
  component: () => import('@/pages/ServicePage.vue'),
  props: { serviceSlug: s.slug }
}))

export default new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve({ selector: to.hash, behavior: 'smooth' })
        }, 300)
      })
    }
    if (savedPosition) return savedPosition
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', name: 'Home', component: () => import('@/index.vue') },

    { path: '/product/', name: 'ProductCenter', component: () => import('@/pages/ProductCenter.vue') },
    { path: '/product/:categorySlug/', name: 'ProductCategory', component: () => import('@/pages/ProductCategory.vue'), props: true },
    { path: '/product/:categorySlug/:id.html', name: 'ProductDetail', component: () => import('@/pages/ProductDetail.vue'), props: route => ({ categorySlug: route.params.categorySlug, id: route.params.id }) },

    { path: '/solution/', redirect: '/case/' },
    { path: '/solution/:solutionSlug/:id.html', redirect: to => '/case/' + to.params.solutionSlug + '/' + to.params.id + '.html' },
    { path: '/solution/:solutionSlug/:subSlug/', redirect: to => '/case/' + to.params.solutionSlug + '/' + to.params.subSlug + '/' },
    { path: '/solution/:solutionSlug/', redirect: to => '/case/' + to.params.solutionSlug + '/' },

    { path: '/case/', redirect: '/case/all/' },
    { path: '/case/:solutionSlug/:id.html', name: 'CaseDetail', component: () => import('@/pages/SolutionDetail.vue'), props: route => ({ solutionSlug: route.params.solutionSlug, id: route.params.id, mode: 'case' }) },
    { path: '/case/:solutionSlug/:subSlug/', name: 'CaseSub', component: () => import('@/pages/SolutionPage.vue'), props: route => ({ solutionSlug: route.params.solutionSlug, subSlug: route.params.subSlug, mode: 'case' }) },
    { path: '/case/:solutionSlug/', name: 'Case', component: () => import('@/pages/SolutionPage.vue'), props: route => ({ solutionSlug: route.params.solutionSlug, mode: 'case' }) },

    { path: '/news/', name: 'NewsAll', component: () => import('@/pages/NewsList.vue'), props: { newsSlug: '' } },
    { path: '/news/:newsSlug/', name: 'NewsCategory', component: () => import('@/pages/NewsList.vue'), props: route => ({ newsSlug: route.params.newsSlug }) },
    { path: '/news/:newsSlug/:id.html', name: 'NewsDetail', component: () => import('@/pages/NewsDetail.vue'), props: route => ({ newsSlug: route.params.newsSlug, id: route.params.id }) },

    { path: '/about/', name: 'About', component: () => import('@/pages/AboutPage.vue') },
    ...aboutRedirects,

    { path: '/service/', redirect: '/service/product-support/' },
    { path: '/service/video-help/', redirect: '/service/product-support/' },
    ...serviceRoutes,

    { path: '/contact/', name: 'Contact', component: () => import('@/pages/ContactUs.vue') },
    { path: '/message/', redirect: '/contact/' },
    { path: '/cn/message/', redirect: '/contact/' },
    { path: '/search/', name: 'Search', component: () => import('@/pages/SearchResults.vue') },

    { path: '*', redirect: '/' }
  ]
})
